(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5XAMO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $456eff698ea43c33$export$2e2bcd8739ae039; });

var $dG89L = parcelRequire("dG89L");

var $786yr = parcelRequire("786yr");

var $hQrCi = parcelRequire("hQrCi");

const $456eff698ea43c33$var$Footer = ()=>{
    const { update: update, submit: submit } = (0, $786yr.default)();
    (0, $dG89L.default)(()=>{
        const form = (0, $hQrCi.default)("#contact-form"), inputs = form.querySelectorAll("input, textarea");
        inputs.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                update(e.target.name, e.target.value);
            });
        });
        form.addEventListener("submit", submit);
    });
    return /*html*/ `
	<footer class="global__footer">
		<section class="footer__wrapper">
			<section class="footer__top">
				<h2>Conectamos para construir el futuro</h2>
	
				<div class="footer__list">
					<h6>Navegaci\xf3n r\xe1pida</h6>
					<ul>
						<li><a href="/voir/suites">Voir Suites</a></li>
						<li><a href="/voir/amenabar">Voir Amen\xe1bar</a></li>
						<li><a href="/voir/palpa">Voir Palpa</a></li>
						<li><a href="/voir/cespedes">Live Voir C\xe9spedes</a></li>
					</ul>
				</div>

				<div class="row">
					<a href="https://api.whatsapp.com/send?phone=5491149705025" target="_blank" role="button">
						<img src="/vector/whatsapp.svg" alt="whatsapp" />
					</a>
					<a href="https://www.instagram.com/wfm.investments/" target="_blank" role="button">
						<img src="/vector/instagram.svg" alt="instagram" />
					</a>
					<a href="https://www.facebook.com/WFMinvestments" target="_blank" role="button">
						<img src="/vector/facebook.svg" alt="facebook" />
					</a>
				</div>
			</section>
	
			<section class="footer__middle">
				<div class="footer__list">
					<ul>
						<li>
							<img src="/vector/location.svg" alt="location" />
							<a href="https://www.google.com.ar/maps/place/Av.+del+Libertador+264,+B1638+Vicente+L%C3%B3pez,+Provincia+de+Buenos+Aires/@-34.532023,-58.4689734,17z/data=!4m16!1m9!3m8!1s0x95bcb6af4f087d41:0xce0e216d324219d7!2sAv.+del+Libertador+264,+B1638+Vicente+L%C3%B3pez,+Provincia+de+Buenos+Aires!3b1!8m2!3d-34.5321057!4d-58.4693111!10e5!16s%2Fg%2F11r_gt5bzv!3m5!1s0x95bcb6af4f087d41:0xce0e216d324219d7!8m2!3d-34.5321057!4d-58.4693111!16s%2Fg%2F11r_gt5bzv?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank">
								Libertador 7766, 4to-06, Nu\xf1ez, CABA.
							</a>
						</li>
						<li>
							<img src="/vector/cellphone.svg" alt="cellphone" />
							<a href="tel:+5491149705025">+54 9 11 4970 5025</a>
						</li>
						<li role="email">
							<img src="/vector/email.svg" alt="email" />
							<a href="mailto:info@wfm.com.ar">info@wfm.com.ar</a>
						</li>
					</ul>
				</div>
	
				<form id="contact-form">
					<div role="name">
						<label for="name">Nombre</label>
						<input type="text" id="name" name="name" placeholder="John" />
					</div>
					<div role="lastname">
						<label for="lastname">Apellido</label>
						<input type="text" id="lastname" name="lastname" placeholder="Smith" />
					</div>
					<div role="email">
						<label for="email">Correo</label>
						<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
					</div>
					<div role="phone">
						<label for="phone">Celular</label>
						<div>
							<p>+54</p>
							<span></span>
							<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
						</div>
					</div>
					<div role="message">
						<label for="message">Mensaje</label>
						<textarea id="message" name="message" rows="5" placeholder="Deja tu mensaje..."></textarea>
					</div>
					<button type="submit">Contactar</button>
				</form>
			</section>
		</section>

		<section class="footer__bottom">
			<a href="/">
				<img src="/vector/wfm-logo.svg" alt="WFM Investments" width="auto" height="25" />
			</a> 
			<p>2025 \xa9 WFM Investments</p>
		</section>
	</footer>`;
};
var $456eff698ea43c33$export$2e2bcd8739ae039 = $456eff698ea43c33$var$Footer;

});
parcelRegister("dG89L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f558654c4b17ad6$export$2e2bcd8739ae039; });
function $9f558654c4b17ad6$var$onceMounted(callback) {
    // is trash i know
    setTimeout(()=>{
        callback();
    }, 50);
}
var $9f558654c4b17ad6$export$2e2bcd8739ae039 = $9f558654c4b17ad6$var$onceMounted;

});

parcelRegister("786yr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $530e5d55363d1cc6$export$2e2bcd8739ae039; });

var $lIgbV = parcelRequire("lIgbV");
const $530e5d55363d1cc6$var$useContactForm = (defaultTemplate = "")=>{
    let mailto = "mailto:";
    let body = {
        phone: "",
        name: "",
        email: "",
        lastname: "",
        message: ""
    };
    const params = {
        cc: "",
        subject: "",
        body: "",
        to: "info@wfm.com.ar"
    };
    const update = (key, value)=>{
        switch(key){
            case "email":
                params.cc = value;
                break;
            case "name":
                body.name = value;
                break;
            case "lastname":
                body.lastname = value;
                break;
            case "phone":
                body.phone = value;
                break;
            case "message":
                body.message = value;
                break;
        }
        const { message: message, ...localBody } = body;
        localStorage.setItem("wfm:body_form", JSON.stringify({
            ...localBody,
            email: params.cc
        }));
    };
    const getLink = ()=>{
        params.subject = "WFM Investments | Contacto";
        params.body = encodeURIComponent(`${defaultTemplate}Nombre: ${body.name}\nApellido: ${body.lastname}\nCelular: ${body.phone}\n---\n${body.message}`);
        return `${mailto}${params.to}?${Object.keys(params).map((key)=>`${key}=${params[key]}`).join("&")}`;
    };
    const submit = (e)=>{
        e.preventDefault();
        window.open(getLink(), "_blank");
    };
    const getData = ()=>{
        const storedData = JSON.parse(localStorage.getItem("wfm:body_form") ?? "{}");
        return {
            ...body,
            ...params,
            ...storedData
        };
    };
    const isReady = ()=>{
        const storedData = JSON.parse(localStorage.getItem("wfm:body_form") || JSON.stringify((0, $lIgbV.BODY_SCHEMA)));
        return storedData.email.length > 0;
    };
    return {
        update: update,
        submit: submit,
        getData: getData,
        isReady: isReady
    };
};
var $530e5d55363d1cc6$export$2e2bcd8739ae039 = $530e5d55363d1cc6$var$useContactForm;

});
parcelRegister("lIgbV", function(module, exports) {

$parcel$export(module.exports, "BODY_SCHEMA", function () { return $fcea4451c7d982de$export$2b3a68d2765a4c50; });
const $fcea4451c7d982de$export$2b3a68d2765a4c50 = {
    phone: "",
    name: "",
    email: "",
    lastname: "",
    message: ""
};

});


parcelRegister("hQrCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfdcb71a8e9c4215$export$2e2bcd8739ae039; });
/** @type {(selector: string) => HTMLElement} */ const $cfdcb71a8e9c4215$var$$ = (selector)=>document.querySelector(selector);
var $cfdcb71a8e9c4215$export$2e2bcd8739ae039 = $cfdcb71a8e9c4215$var$$;

});


parcelRegister("8fSQL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $602a4586c81edbf3$export$2e2bcd8739ae039; });

var $dG89L = parcelRequire("dG89L");

var $lIgbV = parcelRequire("lIgbV");

var $hQrCi = parcelRequire("hQrCi");

const $602a4586c81edbf3$var$Header = (props)=>{
    const storedData = JSON.parse(localStorage.getItem("wfm:body_form") ?? JSON.stringify({
        ...(0, $lIgbV.BODY_SCHEMA)
    }));
    const isReady = storedData.email.length > 0;
    (0, $dG89L.default)(()=>{
        const fixedHeader = (0, $hQrCi.default)("#fixed-header");
        document.addEventListener("scroll", ()=>{
            const scrollTop = window.scrollY;
            if (scrollTop >= 100) fixedHeader.setAttribute("data-open", "true");
            else fixedHeader.setAttribute("data-open", "false");
        });
        const modal = (0, $hQrCi.default)(".nav-modal"), openModal = document.querySelectorAll(".burger-menu"), closeModal = (0, $hQrCi.default)(".close-modal"), links = document.querySelectorAll(".nav-modal nav ul li a");
        closeModal.onclick = ()=>modal.style.display = "none";
        openModal.forEach((btn)=>{
            btn.addEventListener("click", ()=>modal.style.display = "flex");
        });
        links.forEach((link)=>link.addEventListener("click", ()=>modal.style.display = "none"));
        // redirect to bottom of page
        const contactButtons = document.querySelectorAll(".contact-button");
        contactButtons.forEach((el)=>el.addEventListener("click", ()=>window.scrollTo(0, 9999)));
    });
    return /*html*/ `
	<header class="global__header">
		<nav>
			<ul>
				<li><a href="/#projects">Proyectos</a></li>
				<!-- <li><a href="/#oportunities">Oportunidades</a></li>	  -->
				<li>\u{25A0}</li>	
				<li><a href="/aboutus">Nosotros</a></li>	 
			</ul>
		</nav>

		<button class="burger-menu" type="button">
			<img src="/vector/burger-light.svg" width="26" height="auto" alt="burger" />
		</button>
			
		<a href="/">
			<img src="/vector/wfm-logo.svg" width="120" height="auto" alt="logo" />
		</a>

		<div class="buttons__wrapper">
			${props?.brochure ? /*html*/ `
				<div class="form__wrapper__download">
				<button type="button" class="download_brochure_button" data-order="1" data-disable="${isReady}" data-ready="false">
					Brochure
					<img src="/vector/download.svg" alt="download" width="22" height="22" />
				</button>
				<a href="${props?.brochure}" id="download_brochure_link" download hidden></a>
				
				<form id="download_brochure_form" class="bubble__form brochure_1" aria-expanded="false">
					<strong>Complet\xe1 el formulario para conocer m\xe1s sobre el proyecto</strong>
	
					<!-- <div role="name">
						<label for="name">Nombre</label>
						<input type="text" id="name" name="name" placeholder="John" />
					</div>
					<div role="lastname">
						<label for="lastname">Apellido</label>
						<input type="text" id="lastname" name="lastname" placeholder="Smith" />
					</div> -->
					<div role="email">
						<label for="email">Correo</label>
						<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
					</div>
					<!-- <div role="phone">
						<label for="phone">Celular</label>
						<div>
							<p>+54</p>
							<span></span>
							<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
						</div>
					</div> -->
				</form>
				</div>
				` : ""}
			
			<button class="contact-button" type="button">
				<p>Contactar</p>
				<img src="/vector/email-black.svg" width="22" height="22" alt="Contactar" />
			</button>
		</div>
	</header>

	<header class="global__fixed__header" data-open="false" id="fixed-header">
		<nav>
			<ul>
				<li><a href="/#projects">Proyectos</a></li>
				<!-- <li><a href="/#oportunities">Oportunidades</a></li>	  -->
				<li>\u{25A0}</li>	
				<li><a href="/aboutus">Nosotros</a></li>	 
			</ul>
		</nav>

		<button type="button" class="burger-menu">
			<img src="/vector/burger-dark.svg" width="26" height="auto" alt="burger" />
		</button>
			
		<a href="/">
			<img src="/vector/wfm-logo-black.svg" width="120" height="auto" alt="logo" />
		</a>

		<div class="buttons__wrapper">
		${props?.brochure ? /*html*/ `
				<div class="form__wrapper__download">
				<button type="button" class="download_brochure_button redirect_brochure">
					Brochure
					<img src="/vector/download.svg" alt="download" width="22" height="22" />
				</button>
				</div>
				` : ""}
			<button class="contact-button" type="button">
				<p>Contactar</p>
				<img src="/vector/email-white.svg" width="22" height="22" alt="Contactar" />
			</button>
		</div>
	</header>
	
	<div class="nav-modal" style="display: none;">
		<button type="button" class="close-modal">
			<img src="/vector/times.svg" width="26" height="auto" alt="close-modal" />
		</button>
		<nav>
			<ul>
				<li><a href="/#projects">Proyectos</a></li>
				<!-- <li><a href="/#oportunities">Oportunidades</a></li> -->
				<li><a href="/aboutus">Nosotros</a></li>
			</ul>
		</nav>
	</div>`;
};
var $602a4586c81edbf3$export$2e2bcd8739ae039 = $602a4586c81edbf3$var$Header;

});


var $5XAMO = parcelRequire("5XAMO");

var $dG89L = parcelRequire("dG89L");
var $5c0dfe98f8a7cbd3$export$2e2bcd8739ae039 = {
    suites: {
        video: "/videos/suites.mp4",
        tags: [
            "Entrega estimada",
            "Agosto 2027",
            "1, 2 y 3",
            "En construcci\xf3n",
            "Amen\xe1bar 892, CABA"
        ],
        brochure: "/dowloads/03 Voir Suites.pdf",
        sidetext: [
            {
                title: "Creado para vos",
                body: "M\xe1s que un espacio residencial, VOIR Suites es una experiencia pensada para quienes buscan dinamismo, libertad y confort en un solo lugar. Dise\xf1ado con arquitectura contempor\xe1nea y materiales de primer nivel, cada rinc\xf3n de este proyecto redefine el hogar urbano.",
                url: "/pics/suites/Hall Entrada.webp"
            },
            {
                title: "",
                body: "Voir Suites es un desarrollo de 23 unidades modernas y luminosas de uno, dos y tres ambientes. Disfrut\xe1 de un lugar que integra descanso, trabajo y ocio en perfecta armon\xeda. Desde un coworking y laundry, hasta una terraza equipada con jacuzzi y parrilla, VOIR Suites ofrece espacios para disfrutar al m\xe1ximo cada momento del d\xeda.",
                url: "/pics/suites/Terraza.webp"
            },
            {
                title: "Alquiler Temporario Inteligente",
                body: "VOIR Suites incorpora tecnolog\xeda de acceso remoto mediante claves digitales, asegurando comodidad y seguridad para quienes eligen la flexibilidad del alquiler temporario. Bienvenidos a una nueva forma de vivir en Colegiales. Bienvenidos a VOIR Suites.",
                url: "/pics/suites/Edificio Atardecer.webp"
            }
        ],
        carousel: [
            "/pics/suites/Local por Fuera.webp",
            "/pics/suites/Hall Entrada.webp",
            "/pics/suites/3 Amb.webp",
            "/pics/suites/Dormitorio.webp",
            "/pics/suites/Monoambiente.webp",
            //"/pics/suites/Baño.webp",
            "/pics/suites/Sum - Subsuelo.webp",
            "/pics/suites/Terraza.webp",
            "/pics/suites/Edificio Dia.webp",
            "/pics/suites/Edificio Atardecer.webp"
        ],
        map: {
            map: "/pics/suites/map.webp",
            link: "https://www.google.com.ar/maps/place/Amen%C3%A1bar+892,+C1426AJN+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.571546,-58.4507485,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb5c479a147dd:0x6e82f76f8b547b37!8m2!3d-34.571546!4d-58.4481736!16s%2Fg%2F11c4tschy7?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
            location: "Amen\xe1bar 892, CABA",
            title: "Una nueva forma de vivir Colegiales",
            coords: [
                -34.57142229240189,
                -58.44815214594486,
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d797.9403901849287!2d-58.448640216378855!3d-34.57159998717503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5c479a147dd%3A0x6e82f76f8b547b37!2sAmen%C3%A1bar%20892%2C%20C1426AJN%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires%2C%20Argentina!5e0!3m2!1ses-419!2sbo!4v1751672725831!5m2!1ses-419!2sbo"
            ],
            body: "Voir Suites te invita a vivir en el equilibrio perfecto entre la ciudad y la tranquilidad. La comodidad y el bienestar se encuentran en cada detalle, ofreci\xe9ndote un estilo de vida que combina lo mejor de ambos mundos. Colegiales te recibe con una oferta gastron\xf3mica que va desde sus propios rincones secretos hasta los circuitos de Palermo Hollywood y Las Ca\xf1itas, a s\xf3lo unos pasos. Y gracias a su ubicaci\xf3n estrat\xe9gica, Voir Suites conecta con toda la ciudad: estaciones de metrobus, tren y subte est\xe1n a solo 4 cuadras, poniendo todo Buenos Aires a tu alcance. <br/><br/><b>En Voir Suites, no solo encontr\xe1s un hogar, sino un espacio pensado para vivir mejor.</b>"
        },
        environment: {
            Monoambiente: {
                "3D": "/pics/suites/3D/Monoambiente.webp",
                "2D": "/pics/suites/2D/Monoambiente.webp",
                surface: "35,39 m2",
                environments: 1,
                bathrooms: 1,
                rooms: 1
            },
            "2 Ambientes": {
                "3D": "/pics/suites/3D/2 Ambientes.webp",
                "2D": "/pics/suites/2D/2 Ambientes.webp",
                surface: "42,09 m2",
                environments: 2,
                bathrooms: 1,
                rooms: 1
            },
            "3 Ambientes": {
                "3D": "/pics/suites/3D/3 Ambientes.webp",
                "2D": "/pics/suites/2D/3 Ambientes.webp",
                surface: "63,26 m2",
                environments: 3,
                bathrooms: 1,
                toilets: 1,
                rooms: 1
            },
            "3 Ambientes con Terraza": {
                "3D": "/pics/suites/3D/3 Ambientes con Terraza.webp",
                "2D": "/pics/suites/2D/3 Ambientes con Terraza.webp",
                surface: "123,71 m2",
                environments: 3,
                bathrooms: 2,
                toilets: 1,
                rooms: 2
            }
        }
    },
    amenabar: {
        video: "/videos/amenabar.mp4",
        tags: [
            "\xdaltima unidad disponible",
            " ",
            "1, 2, 3 y 4",
            "Finalizado",
            "Amen\xe1bar 2913, CABA"
        ],
        brochure: "/dowloads/BROCHURE_VOIR_AMENABAR.pdf",
        sidetext: [
            {
                title: "El nuevo Life-Style",
                body: "Voir Amen\xe1bar combina el equilibrio y la elegancia en una semi-torre moderna de 16 pisos que redefine el estilo de vida en Belgrano. Este proyecto es la fusi\xf3n perfecta entre la calidez de un hogar y la seguridad de un edificio de alta gama, dise\xf1ado para aprovechar la luz natural y brindar un entorno armonioso.",
                url: "/pics/amenabar/IMG_7868.webp"
            },
            {
                title: "",
                body: `Cada espacio esta pensado para disfrutar, donde el dise\xf1o y el entorno se complementan en perfecta sinton\xeda. La propuesta de Voir Amen\xe1bar incluye un conjunto de servicios y espacios de esparcimiento, dise\xf1ados para potenciar el confort de sus residentes:
        <br/><br/>
        <ul>
            <li>Gimnasio</li>
            <li>Pileta y Solarium</li>
            <li>SUM, parrilla y terraza</li>
            <li>Laundry</li>
            <li>Bauleras y cocheras cubiertas</li>
        </ul>`,
                url: "/pics/amenabar/Pileta.webp"
            },
            {
                title: "Vivi\u0301 Voir Amen\xe1bar",
                body: "Un nuevo est\xe1ndar de vida urbana en Belgrano, donde el confort y la calidad de vida est\xe1n siempre a la altura.",
                url: "/pics/amenabar/Frente.webp"
            }
        ],
        carousel: [
            "/pics/amenabar/Frente.webp",
            "/pics/amenabar/IMG_9511.webp",
            "/pics/amenabar/IMG_9440.webp",
            "/pics/amenabar/IMG_9522.webp",
            "/pics/amenabar/Pileta2.webp",
            "/pics/amenabar/Pileta.webp",
            "/pics/amenabar/Terraza2.webp",
            "/pics/amenabar/Parrilla.webp",
            "/pics/amenabar/Terraza.webp",
            "/pics/amenabar/Gym.webp"
        ],
        map: {
            map: "/pics/amenabar/map.webp",
            link: "https://www.google.com.ar/maps/place/Amen%C3%A1bar+2913,+C1429+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.5562002,-58.4668943,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb68221d35fa5:0x33a4971fe1937203!8m2!3d-34.5562002!4d-58.4643194!16s%2Fg%2F11h0t1wbwl?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
            title: "Encontr\xe1 tu hogar! Belgrano",
            location: "Amen\xe1bar 2913, CABA",
            body: "Amen\xe1bar se sit\xfaa en el centro de Belgrano, uno de los barrios m\xe1s din\xe1micos y seguros de Buenos Aires. Su ubicaci\xf3n estrat\xe9gica ofrece r\xe1pido acceso a Av. Cabildo, Av. Congreso y los principales medios de transporte p\xfablico, como la l\xednea D de subte y el Metrob\xfas. Se encuentra a solo minutos de centros m\xe9dicos, prestigiosas instituciones educativas, comercios, clubes y una variada oferta gastron\xf3mica. Belgrano tambi\xe9n brinda amplios espacios verdes para disfrutar al aire libre, convirti\xe9ndolo en el entorno perfecto para un estilo de vida equilibrado. <br/><br/><b>Una ubicaci\xf3n que lo tiene todo: Conectividad, Seguridad y Confort</b>",
            coords: [
                -34.5559969458807,
                -58.464287217109636,
                "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3285.903569077359!2d-58.466867488826196!3d-34.55599687285869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDMzJzIxLjYiUyA1OMKwMjcnNTEuNCJX!5e0!3m2!1ses-419!2sar!4v1743687087913!5m2!1ses-419!2sar"
            ]
        },
        environment: {
            "Duplex Penthouse": {
                UP: "/pics/amenabar/UP/Duplex Penthouse.png",
                DOWN: "/pics/amenabar/DOWN/Duplex Penthouse.png",
                surface: "80 m2",
                environments: 3,
                bathrooms: 2,
                rooms: 2
            }
        }
    },
    palpa: {
        video: "/videos/palpa.mp4",
        tags: [
            "Vendido",
            "",
            "1, 2 y 3",
            "Finalizado",
            "Palpa 2634, CABA"
        ],
        brochure: "/dowloads/Voir Palpa Carpeta NEW_V2.pdf",
        sidetext: [
            {
                title: "Dise\xf1o de Vanguardia",
                body: "Voir Palpa redefine la vida en Colegiales, pensado para quienes valoran un hogar que se adapta a cada momento. Este proyecto integra descanso, trabajo y ocio en espacios modernos, dise\xf1ados para aprovechar la luz natural y ofrecer una experiencia de vida c\xf3moda y flexible.",
                url: "/pics/palpa/VR_IRIVAS_PALPA_VISTA9_PARRILLA_A03.webp"
            },
            {
                title: "",
                body: "Con arquitectura contempor\xe1nea y acabados de alta calidad, Voir Palpa tiene 25 unidades modernas que ofrecen un entorno pensado para el bienestar y la inspiraci\xf3n. Cada detalle refleja el compromiso con el confort y la funcionalidad, en una ubicaci\xf3n que te conecta con todo lo que necesitas para vivir plenamente.",
                url: "/pics/palpa/IMG_9905.webp"
            },
            {
                title: "Vivi\u0301 Voir Palpa",
                body: "Ubicado en el coraz\xf3n de Colegiales, Voir Palpa es m\xe1s que un hogar: es un lugar donde el dise\xf1o y la ciudad se encuentran para ofrecerte un estilo de vida activo, conectado y completo.",
                url: "/pics/palpa/VR_IRIVAS_PALPA_VISTA5_DEPTO FRENTE APAISADO 207_A03.webp"
            }
        ],
        carousel: [
            "/pics/palpa/IMG_0082.webp",
            "/pics/palpa/IMG_0056.webp",
            "/pics/palpa/IMG_9956.webp",
            "/pics/palpa/IMG_0027.webp",
            "/pics/palpa/IMG_0021.webp",
            "/pics/palpa/IMG_9905.webp",
            "/pics/palpa/IMG_9981.webp",
            "/pics/palpa/IMG_9918.webp",
            //"/pics/palpa/VR_IRIVAS_PALPA_VISTA7_BAÑO_A03.webp",
            "/pics/palpa/IMG_0077.webp",
            "/pics/palpa/IMG_0073.webp",
            "/pics/palpa/Foto Pileta Dic. 2023.webp"
        ],
        map: {
            map: "/pics/palpa/map.webp",
            link: "https://www.google.com.ar/maps/place/Palpa+2634,+C1426DOH+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.5715145,-58.4508239,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb5c4791132cd:0x768909390f619cb2!8m2!3d-34.5715145!4d-58.448249!16s%2Fg%2F11hzxqbpvp?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
            title: "Colegiales<br/> se renueva con VOIR PALPA",
            location: "Palpa 2634, CABA",
            body: "Con excelente conectividad, a solo cuatro cuadras ten\xe9s acceso al metrob\xfas, subte y tren, lo que te permitir\xe1 desplazarte c\xf3modamente por toda Buenos Aires.<br /><br />Desde Voir Palpa vas a disfrutar de una amplia variedad de opciones gastron\xf3micas y culturales a minutos de distancia: desde los \u201Crincones\u201D de Colegiales hasta los reconocidos circuitos de Palermo Hollywood y Las Ca\xf1itas.<br /><br />VOIR Palpa: Dise\xf1o, confort y conexi\xf3n en uno de los barrios m\xe1s atractivos de la ciudad.",
            coords: [
                -34.57140846102497,
                -58.44825973245216,
                "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3285.2947223603487!2d-58.45083998882548!3d-34.57140847285312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDM0JzE3LjEiUyA1OMKwMjYnNTMuNyJX!5e0!3m2!1ses-419!2sar!4v1743687151805!5m2!1ses-419!2sar"
            ]
        },
        environment: {
            "Local Comercial": {
                "2D": "/pics/palpa/2D/Local Comercial.png",
                surface: "82,48 m2",
                environments: 1,
                bathrooms: 1,
                kitchens: 1
            }
        }
    },
    cespedes: {
        video: "/videos/cespedes.mp4",
        tags: [
            "Entrega estimada",
            "2028",
            "1, 2 y 3",
            "Etapa de Inicio de Obra",
            "C\xe9spedes 2518, CABA"
        ],
        brochure: "/dowloads/01 Live Voir C\xe9spedes.pdf",
        sidetext: [
            {
                title: "LIVE VOIR C\xe9spedes",
                body: "Es un proyecto \xfanico, desarrollado en colaboraci\xf3n con nuestros socios de Urban Estate, representa una alianza estrat\xe9gica que da lugar a un emprendimiento excepcional, pensado para ofrecer lo mejor en cada detalle.",
                url: "/pics/cespedes/1.jpeg"
            },
            {
                title: "",
                body: "Este moderno desarrollo de 10 pisos ofrece espacios comunes pensados para tu bienestar, constituido por los amenities del edificio tales como piscina, sol\xe1rium y zona de parrilla, aprovechando al m\xe1ximo las visuales abiertas que brinda la esquina y su orientaci\xf3n Norte.",
                url: "/pics/cespedes/10.jpeg"
            },
            {
                title: "",
                body: "Vivir en un emprendimiento moderno en Belgrano es la oportunidad ideal para disfrutar de un estilo de vida que combina confort y conveniencia para toda la familia. Cada detalle est\xe1 pensado para hacer tu d\xeda a d\xeda m\xe1s placentero, en un entorno que ofrece la tranquilidad y el confort que mereces, sin renunciar a las ventajas de la vida urbana.",
                url: "/pics/cespedes/8.jpeg"
            }
        ],
        carousel: [
            "/pics/cespedes/1.jpeg",
            "/pics/cespedes/2.jpeg",
            "/pics/cespedes/3.jpeg",
            "/pics/cespedes/4.jpeg",
            "/pics/cespedes/5.jpeg",
            "/pics/cespedes/6.jpeg",
            "/pics/cespedes/7.jpeg",
            "/pics/cespedes/8.jpeg",
            "/pics/cespedes/9.jpeg",
            "/pics/cespedes/10.jpeg"
        ],
        map: {
            map: "/pics/palpa/map.webp",
            link: "https://www.google.com.ar/maps/place/C%C3%A9spedes+2518,+C1426DUJ+Cdad.+Aut%C3%B3noma+de+Buenos+Aires/@-34.5698755,-58.4518527,17z/data=!3m1!4b1!4m6!3m5!1s0x95bcb5c4fc823d0d:0x246a70498e26d6f7!8m2!3d-34.5698755!4d-58.4492778!16s%2Fg%2F11h553t4pl?entry=ttu&g_ep=EgoyMDI1MDEwNi4xIKXMDSoASAFQAw%3D%3D",
            title: "Belgrano - LIVE VOIR",
            location: "C\xe9spedes 2518, CABA",
            body: "La comodidad y conectividad se encuentran en esta esquina privilegiada de Belgrano.<br/><br/>A tan solo unos pasos de la estaci\xf3n de tren Colegiales y a pocas cuadras de las estaciones de subte D, Olleros y Jos\xe9 Hern\xe1ndez, tendr\xe1s acceso r\xe1pido y directo a las principales v\xedas de transporte de la ciudad. Adem\xe1s, su cercan\xeda a la Av. Cabildo te garantiza una excelente conexi\xf3n con el resto de la ciudad, facilitando tus desplazamientos y acerc\xe1ndote a todos los servicios y comodidades que necesitas para vivir de manera plena y conveniente.",
            coords: [
                -34.56976062442709,
                -58.44926707478073,
                "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3285.3598352250915!2d-58.45184738882564!3d-34.56976057285361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDM0JzExLjEiUyA1OMKwMjYnNTcuNCJX!5e0!3m2!1ses-419!2sar!4v1743687312900!5m2!1ses-419!2sar"
            ]
        },
        environment: {
            "3 Ambientes": {
                "2D": "/pics/cespedes/2D/3 Ambientes.png",
                surface: "64,80 m2",
                environments: 3,
                toilets: 1,
                bathrooms: 1,
                rooms: 2
            },
            "3 Ambientes con 2 Balcones": {
                "2D": "/pics/cespedes/2D/3 Ambientes con 2 Balcones.png",
                surface: "76,86 m2",
                environments: 3,
                bathrooms: 1,
                toilets: 1,
                rooms: 2
            },
            "Monoambiente Divisible": {
                "2D": "/pics/cespedes/2D/Monoambiente Divisible.png",
                surface: "40,87 m2",
                environments: 1,
                bathrooms: 1,
                rooms: 1
            },
            "2 Ambientes Divisible": {
                "2D": "/pics/cespedes/2D/2 Ambientes Divisible.png",
                surface: "49,28 m2",
                environments: 2,
                bathrooms: 1,
                rooms: 1
            },
            "2 Ambientes": {
                "2D": "/pics/cespedes/2D/2 Ambientes.png",
                surface: "56,01 m2",
                environments: 2,
                bathrooms: 1,
                rooms: 1
            }
        }
    }
};


const $dba38e4bae7d99e0$export$b97583b55a764771 = {
    surface: "Superficie comercial",
    environments: "Ambientes",
    bathrooms: "Ba\xf1os",
    rooms: "Dormitorios",
    toilets: "Toilettes",
    kitchens: "Cocinas"
};
const $dba38e4bae7d99e0$export$7705b3ca49e48554 = [
    "surface",
    "environments",
    "rooms",
    "kitchens",
    "bathrooms",
    "toilets"
];


const $ccc9815659eebd47$var$AVAILABLE_KEYS = Object.keys((0, $5c0dfe98f8a7cbd3$export$2e2bcd8739ae039)); // ["amenabar", "cespedes", ...]
const $ccc9815659eebd47$var$usePage = ()=>{
    const pathname = window.location.pathname;
    // Extrae el nombre del proyecto desde la URL (funciona con /index.html o /)
    const match = pathname.match(/^\/voir\/([^/]+)/);
    const key = match?.[1];
    if (!$ccc9815659eebd47$var$AVAILABLE_KEYS.includes(key)) {
        window.location.replace("/");
        throw new Error("Page not found");
    }
    /** @type {Page} */ const page = (0, $5c0dfe98f8a7cbd3$export$2e2bcd8739ae039)[key];
    const getMapInfo = ()=>page.map;
    const getVideo = ()=>page.video;
    const getName = ()=>key.charAt(0).toUpperCase() + key.slice(1);
    const getSidetext = ()=>page.sidetext;
    const getCarousel = ()=>page.carousel;
    const getTags = ()=>{
        const [entrega, period, environments, state, location] = page.tags;
        return {
            entrega: entrega,
            period: period,
            environments: environments,
            state: state,
            location: location
        };
    };
    const getEnvImage = (env, dimension)=>page.environment[env][dimension];
    const getEnvs = ()=>Object.keys(page.environment);
    const getAvailableDimesions = (env)=>Object.keys(page.environment[env]).filter((k)=>![
                "surface",
                "environments",
                "bathrooms",
                "rooms",
                "toilets",
                "kitchens"
            ].includes(k));
    const getAvailableSpecs = (env)=>Object.keys(page.environment[env]).filter((k)=>[
                "surface",
                "environments",
                "bathrooms",
                "rooms",
                "toilets",
                "kitchens"
            ].includes(k)).sort((a, b)=>(0, $dba38e4bae7d99e0$export$7705b3ca49e48554).indexOf(a) - (0, $dba38e4bae7d99e0$export$7705b3ca49e48554).indexOf(b));
    const getEnvSpecs = (env)=>{
        const { bathrooms: bathrooms, rooms: rooms, environments: environments, surface: surface, toilets: toilets, kitchens: kitchens } = page.environment[env];
        return {
            bathrooms: bathrooms,
            rooms: rooms,
            environments: environments,
            surface: surface,
            toilets: toilets,
            kitchens: kitchens
        };
    };
    const getEnvDefaults = ()=>{
        const defaultKey = Object.keys(page.environment)[0];
        const specs = getEnvSpecs(defaultKey);
        const availableDimesions = getAvailableDimesions(defaultKey);
        const availableSpecs = getAvailableSpecs(defaultKey);
        const preview = getEnvImage(defaultKey, availableDimesions[0]);
        return {
            key: defaultKey,
            preview: preview,
            specs: specs,
            availableDimesions: availableDimesions,
            availableSpecs: availableSpecs
        };
    };
    const getBrochure = ()=>page.brochure;
    return {
        getMapInfo: getMapInfo,
        getVideo: getVideo,
        getName: getName,
        getSidetext: getSidetext,
        getCarousel: getCarousel,
        getTags: getTags,
        getEnvImage: getEnvImage,
        getEnvs: getEnvs,
        getEnvSpecs: getEnvSpecs,
        getEnvDefaults: getEnvDefaults,
        getBrochure: getBrochure,
        getAvailableDimesions: getAvailableDimesions,
        getAvailableSpecs: getAvailableSpecs
    };
};
var $ccc9815659eebd47$export$2e2bcd8739ae039 = $ccc9815659eebd47$var$usePage;



var $786yr = parcelRequire("786yr");

var $95YYf = parcelRequire("95YYf");

var $8fSQL = parcelRequire("8fSQL");

var $hQrCi = parcelRequire("hQrCi");

const $c5c1deb43e9c5441$var$VoirLandingPage = ()=>{
    const { getVideo: getVideo, getTags: getTags, getName: getName, getBrochure: getBrochure } = (0, $ccc9815659eebd47$export$2e2bcd8739ae039)();
    const video = getVideo();
    const tags = getTags();
    const name = getName();
    const brochure = getBrochure();
    const { update: update /* submit */  } = (0, $786yr.default)(`VOIR ${name}\n\n`);
    const { update: updateMail, getData: getDataMail, isReady: isReady } = (0, $786yr.default)();
    (0, $dG89L.default)(()=>{
        const bubbleForm = (0, $hQrCi.default)(`.bubble__form.brochure_1`);
        // redirect to top of page
        const downloadBrochureRedirect = document.querySelectorAll(".redirect_brochure");
        downloadBrochureRedirect.forEach((el)=>el.addEventListener("click", ()=>window.scrollTo(0, 0)));
        const downloadBrochure = document.querySelectorAll(".download_brochure_button");
        // const allInputs = bubbleForm.querySelectorAll("input, textarea");
        // const isValid = () =>
        //   Array.from(allInputs).every((input) => input.value.length > 0);
        // allInputs.forEach((input) => {
        //   input.addEventListener("input", (e) => {
        //     downloadBrochure.forEach((el) =>
        //       el.setAttribute("data-ready", String(isValid()))
        //     );
        //   });
        // });
        // brochure form
        const formBrochure = (0, $hQrCi.default)("#download_brochure_form"), inputsBrochure = formBrochure.querySelectorAll("input, textarea");
        inputsBrochure.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                updateMail(e.target.name, e.target.value);
            });
        });
        downloadBrochure.forEach((el)=>{
            el.addEventListener("click", (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                ev.stopImmediatePropagation();
                if (isReady()) {
                    const { name: name, lastname: lastname, cc: cc, email: email, phone: phone } = getDataMail();
                    (0, $95YYf.Mail).send({
                        email: cc || email,
                        name: `${email}`,
                        subject: `Descarga de brochure | ${email}`,
                        body: `Correo: ${email}
---
Descarg\xf3 brochure ${getName()}`
                    }).catch(console.error);
                    (0, $hQrCi.default)("#download_brochure_link").click();
                    // Reset
                    setTimeout(()=>{
                        // allInputs.forEach((input) => (input.value = ""));
                        bubbleForm.setAttribute("aria-expanded", String(false));
                        el.setAttribute("data-ready", String(false));
                    }, 250);
                    return;
                }
                const expanded = bubbleForm.getAttribute("aria-expanded") === "false";
                bubbleForm.setAttribute("aria-expanded", String(expanded));
            });
        });
        // page contact form
        const pageContactForm = (0, $hQrCi.default)("#page-contact-form"), inputs = pageContactForm.querySelectorAll("input, textarea");
        inputs.forEach((input)=>{
            input.addEventListener("input", (e)=>{
                update(e.target.name, e.target.value);
            });
        });
    });
    return /*html*/ `
	${(0, $8fSQL.default)({
        brochure: brochure
    })}
	<section class="voir__landing__page">
		<span class="bubble_actions">
			<a href="https://api.whatsapp.com/send?phone=5491149705025" target="_blank" role="whatsapp">
				<img src="/vector/whatsapp.svg" alt="whatsapp" width="23" height="23" />
			</a>
		</span>

		<div class="voir__landing__page__topinfo">
			<!-- <span role="back">
				<img src="/vector/arrow-back.svg" alt="arrow-back" />
				<a href="/#projects">Volver a proyectos</a>
			</span> -->
			<span role="logo">
				<img src="/vector/VOIR.logo.svg" alt="VOIR" />
				<h1>${name}</h1>
			</span>

			<div class="form__wrapper">
				<form id="page-contact-form">
					<div role="name">
						<label for="name">Nombre</label>
						<input type="text" id="name" name="name" placeholder="John" />
					</div>
					<div role="lastname">
						<label for="lastname">Apellido</label>
						<input type="text" id="lastname" name="lastname" placeholder="Smith" />
					</div>
					<div role="email">
						<label for="email">Correo</label>
						<input type="email" id="email" name="email" placeholder="tu@dominio.com" />
					</div>
					<div role="phone">
						<label for="phone">Celular</label>
						<div>
							<p>+54</p>
							<span></span>
							<input type="text" id="phone" name="phone" placeholder="11 1234 1234" />
						</div>
					</div>
					<div role="message">
						<label for="message">Mensaje</label>
						<textarea id="message" name="message" rows="5" placeholder="Deja tu mensaje..."></textarea>
					</div>
					<button type="submit">Contactar</button>
				</form>
			</div>
		</div>


		<div class="voir__landing__page__content">
			<div class="voir__landing__page__loop">
				<video src="${video}" autoplay muted loop playsinline></video>
				<!-- <img src="/textures/noise.png" /> -->
			</div>

			<ul class="voir__landing__page__content__list">
				<li>
					<img src="/vector/calendar-dark.svg" alt="calendar" width="20" height="20" />
					<b>${tags.entrega}</b>
					<p>${tags.period}</p>
				</li>
				<li>
					<img src="/vector/building-dark.svg" alt="building" width="20" height="20" />
					<b>Ambientes</b>
					<p>${tags.environments}</p>
				</li>
				<li>
					<img src="/vector/state-dark.svg" alt="state" width="20" height="20" />
					<b>Estado</b>
					<p>${tags.state}</p>
				</li>
				<li>
					<img src="/vector/location-dark.svg" alt="location" width="20" height="20" />
					<b>Ubicaci\xf3n</b>
					<p>${tags.location}</p>
				</li>
			</ul>
		</div>
	</section>`;
};
var $c5c1deb43e9c5441$export$2e2bcd8739ae039 = $c5c1deb43e9c5441$var$VoirLandingPage;



var $lIgbV = parcelRequire("lIgbV");

const $caba99b41008490c$var$ImageSidetext = ({ url: url, title: title, body: body, brochure: brochure, side: side = 'left' })=>{
    const storedData = JSON.parse(localStorage.getItem("wfm:body_form") ?? JSON.stringify({
        ...(0, $lIgbV.BODY_SCHEMA)
    }));
    const isReady = storedData.email.length > 0;
    return /*html*/ `
		<article class="image__sidetext">
			<img src="${url}" data-side="${side}" alt="image-${title}" />
			<div>
				<h4>${title}</h4>
				<p>${body}</p>
				${brochure ? /*html*/ `
				<div class="form__wrapper__download">
				<button type="button" class="download_brochure_button redirect_brochure">
					Brochure
					<img src="/vector/download.svg" alt="download" width="22" height="22" />
				</button>
				</div>
			` : ""}
			</div>
		</article>
	`;
};
var $caba99b41008490c$export$2e2bcd8739ae039 = $caba99b41008490c$var$ImageSidetext;



var $hQrCi = parcelRequire("hQrCi");

var $dG89L = parcelRequire("dG89L");


const $b01af831ba87d0c3$var$Carousel = ()=>{
    const { getCarousel: getCarousel } = (0, $ccc9815659eebd47$export$2e2bcd8739ae039)();
    const carousel = getCarousel();
    let selected = 0;
    (0, $dG89L.default)(()=>{
        const prev = (0, $hQrCi.default)("#prev"), next = (0, $hQrCi.default)("#next"), carousel = (0, $hQrCi.default)("#carousel"), preview = (0, $hQrCi.default)("#preview");
        const children = carousel.children;
        Array.from(carousel.children).forEach((child, i)=>{
            child.onclick = ()=>{
                selected = i;
                carousel.scrollTo({
                    left: selected * carousel.children[0].width,
                    behavior: "smooth"
                });
                Array.from(carousel.children).forEach((child, i)=>{
                    child.setAttribute("aria-selected", i === selected);
                });
                preview.setAttribute("src", children[selected].src);
            };
        });
        prev.onclick = ()=>{
            selected = selected > 0 ? selected - 1 : carousel.children.length - 1;
            carousel.scrollTo({
                left: selected * carousel.children[0].width,
                behavior: "smooth"
            });
            Array.from(carousel.children).forEach((child, i)=>{
                child.setAttribute("aria-selected", i === selected);
            });
            preview.setAttribute("src", children[selected].src);
        };
        next.onclick = ()=>{
            selected = selected < carousel.children.length - 1 ? selected + 1 : 0;
            carousel.scrollTo({
                left: selected * carousel.children[0].width,
                behavior: "smooth"
            });
            Array.from(carousel.children).forEach((child, i)=>{
                child.setAttribute("aria-selected", i === selected);
            });
            preview.setAttribute("src", children[selected].src);
        };
        // --- Drag horizontal para #carousel ---
        let isDragging = false;
        let startX;
        let scrollLeft;
        let moved = false;
        carousel.addEventListener("mousedown", (e)=>{
            isDragging = true;
            moved = false;
            carousel.classList.add("dragging");
            startX = e.pageX - carousel.offsetLeft;
            scrollLeft = carousel.scrollLeft;
        });
        carousel.addEventListener("mousemove", (e)=>{
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - carousel.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 5) moved = true;
            carousel.scrollLeft = scrollLeft - walk;
        });
        carousel.addEventListener("mouseup", ()=>{
            isDragging = false;
            carousel.classList.remove("dragging");
        });
        carousel.addEventListener("mouseleave", ()=>{
            isDragging = false;
            carousel.classList.remove("dragging");
        });
        // Previene clics en imágenes si hubo drag
        Array.from(carousel.querySelectorAll("img")).forEach((img)=>{
            img.addEventListener("click", (e)=>{
                if (moved) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            });
        });
    });
    return /*html*/ `
	<section class="voir__carousel">
		<img src="${carousel[0]}" alt="image-0" id="preview" />

		<div class="voir__carousel__actions">
			<button id="prev" type="button">
				<img src="/vector/chevron-left-white.svg" height="24" width="24" />
			</button>
			<button id="next" type="button">
				<img src="/vector/chevron-right-white.svg" height="24" width="24" />
			</button>
		</div>

		<div class="voir__carousel__rest__images" id="carousel">
			${carousel.map((url, i)=>`<img src="${url}" data-key="${i}" alt="image-${i}" aria-selected="${selected === i}" draggable="false"/>`).join("")}
		</div>
	</section>`;
};
var $b01af831ba87d0c3$export$2e2bcd8739ae039 = $b01af831ba87d0c3$var$Carousel;



var $dG89L = parcelRequire("dG89L");


const $c8fe552aeac3cb2f$var$Location = ()=>{
    const { getMapInfo: getMapInfo, getName: getName } = (0, $ccc9815659eebd47$export$2e2bcd8739ae039)();
    const name = getName();
    const { title: title, body: body, location: location, coords: coords } = getMapInfo();
    const [lat, lng, mapUrl] = coords;
    document.title = `WFM Investments | VOIR ${name}`;
    (0, $dG89L.default)(()=>{
        const info = document.getElementById("location-info"), map = document.getElementById("location-map");
        map.style.height = `${info.clientHeight}px`;
    });
    // Create the Google Maps embed URL using the coordinates with a marker pin you can get the mapUrl from google maps share -> embed map
    const mapEmbedUrl = mapUrl || `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d${lng}!3d${lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM0LCsDM0JzE3LjAiUyA1OMKwMjYnNTMuNCJX!5e0!3m2!1sen!2sus!4v1650000000000!5m2!1sen!2sus`;
    // Add marker parameter separately for clarity
    //const mapEmbedUrlWithMarker = `${mapEmbedUrl}&markers=color:red|${lat},${lng}`;
    return /*html*/ `
	<section class="voir__location">
		<div class="voir__location__map" id="location-map">
			<iframe 
                src="${mapEmbedUrl}" 
                width="100%" 
                height="100%" 
                style="border: 0; filter: grayscale(100%) brightness(90%) contrast(110%);" 
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
		</div>

		<div class="voir__location__info" id="location-info">
			<h4>${title}</h4>
			<i>${location}</i>
			<p>${body}</p>
		</div>
	</section>`;
};
var $c8fe552aeac3cb2f$export$2e2bcd8739ae039 = $c8fe552aeac3cb2f$var$Location;



var $hQrCi = parcelRequire("hQrCi");


var $dG89L = parcelRequire("dG89L");


const $fc88978aa06ef639$var$Environments = ()=>{
    const { getEnvImage: getEnvImage, getEnvs: getEnvs, getEnvSpecs: getEnvSpecs, getEnvDefaults: getEnvDefaults, getAvailableDimesions: getAvailableDimesions, getAvailableSpecs: getAvailableSpecs } = (0, $ccc9815659eebd47$export$2e2bcd8739ae039)();
    const { key: defaultKey, preview: defaultPreview, specs: defaultSpecs, availableDimesions: defaultAvailableDimesions, availableSpecs: defaultAvailableSpecs } = getEnvDefaults();
    const envs = getEnvs();
    let key = defaultKey;
    let dimension = defaultAvailableDimesions[0];
    (0, $dG89L.default)(()=>{
        const selectedEnv = (0, $hQrCi.default)("#selected-env"), envBadgets = document.querySelectorAll("#envs span");
        const applyBadgetListener = ()=>{
            const dimBadgets = document.querySelectorAll("#dimensions span");
            const listener = (badget, i)=>(ev)=>{
                    ev.preventDefault();
                    dimension = badget.id;
                    changeSelected(dimBadgets, i);
                    changePreview(key, dimension);
                };
            dimBadgets.forEach((badget, i)=>{
                badget.addEventListener("click", listener(badget, i));
            });
        };
        /** @type {(els: HTMLElement[], tgt: number) => void} */ const changeSelected = (els, tgt)=>{
            els.forEach((el)=>el.setAttribute("aria-selected", false));
            els[tgt].setAttribute("aria-selected", true);
        };
        const changeAvailableDimesions = (key)=>{
            const dimensions = getAvailableDimesions(key);
            const el = (0, $hQrCi.default)("#dimensions");
            el.innerHTML = dimensions.map((d, i)=>/*html*/ `<span aria-selected="${i === 0}" id="${d}">${d}</span>`).join("");
            applyBadgetListener();
            return dimensions[0];
        };
        /** @type {(key: string) => void} */ const changeSpecs = (key)=>{
            const specs = getEnvSpecs(key);
            const availableSpecs = getAvailableSpecs(key);
            const el = (0, $hQrCi.default)("#specs");
            el.innerHTML = availableSpecs.map((s)=>{
                const label = (0, $dba38e4bae7d99e0$export$b97583b55a764771)[s];
                return /*html*/ `<li>
          <p>${label}</p>
          <b id="spec-${s}">${specs[s]}</b>
        </li>`;
            }).join("");
            const surface = (0, $hQrCi.default)(`#spec-surface`), environments = (0, $hQrCi.default)(`#spec-environments`), bathrooms = (0, $hQrCi.default)(`#spec-bathrooms`), rooms = (0, $hQrCi.default)(`#spec-rooms`), toilets = (0, $hQrCi.default)(`#spec-toilets`);
            if (specs.surface) surface.textContent = specs.surface;
            if (specs.environments) environments.textContent = specs.environments;
            if (specs.bathrooms) bathrooms.textContent = specs.bathrooms;
            if (specs.rooms) rooms.textContent = specs.rooms;
            if (specs.toilets) toilets.textContent = specs.toilets;
        };
        const changePreview = (key = key, dimension = dimension)=>{
            const img = (0, $hQrCi.default)("#unit-preview");
            const src = getEnvImage(key, dimension);
            img.setAttribute("src", src);
        };
        applyBadgetListener();
        envBadgets.forEach((badget, i)=>{
            badget.onclick = (ev)=>{
                ev.preventDefault();
                key = badget.textContent;
                selectedEnv.textContent = badget.textContent;
                changeSelected(envBadgets, i);
                changeSpecs(key);
                const newDimension = changeAvailableDimesions(key);
                changePreview(key, newDimension);
            };
        });
    });
    return /*html*/ `
	<section class="voir__environments">
		<div class="voir__environments__info">
			<h4>Unidades disponibles</h4>
			<i id="selected-env">${defaultKey}</i>

			<ul id="specs">
        <li>
					<p>Precio</p>
					<b>Consultar</b>
				</li>
        ${defaultAvailableSpecs.map((s)=>{
        return /*html*/ `<li>
              <p>${(0, $dba38e4bae7d99e0$export$b97583b55a764771)[s]}</p>
              <b id="spec-${s}">${defaultSpecs[s]}</b>
            </li>`;
    }).join("")}
			</ul>

			<div class="voir__environments__envs" id="envs">
				${envs.map((env, i)=>{
        const id = env.split(" ").join("");
        return /*html*/ `<span aria-selected="${i === 0}" id="${id}">${env}</span>`;
    }).join("")}
			</div>
		</div>

		<div class="voir__environments__preview">
      <div class="voir__environments__dimensions" id="dimensions">
      ${defaultAvailableDimesions.map((d, i)=>/*html*/ `<span aria-selected="${i === 0}" id="${d}">${d}</span>`).join("")}
      </div>
      <img id="unit-preview" src="${defaultPreview}" alt="3D or 2D plan" />
		</div>
	</section>`;
};
var $fc88978aa06ef639$export$2e2bcd8739ae039 = $fc88978aa06ef639$var$Environments;





const { getSidetext: $0c5d6d1bcb68adf1$var$getSidetext, getBrochure: $0c5d6d1bcb68adf1$var$getBrochure } = (0, $ccc9815659eebd47$export$2e2bcd8739ae039)();
const $0c5d6d1bcb68adf1$var$brochurePath = $0c5d6d1bcb68adf1$var$getBrochure();
const $0c5d6d1bcb68adf1$var$sidetext = $0c5d6d1bcb68adf1$var$getSidetext();
document.getElementById("root").innerHTML = /*html*/ `
	${(0, $c5c1deb43e9c5441$export$2e2bcd8739ae039)()}
  ${$0c5d6d1bcb68adf1$var$sidetext.map(({ body: body, title: title, url: url }, i)=>{
    const side = i % 2 == 0 ? "left" : "right";
    const brochure = i === $0c5d6d1bcb68adf1$var$sidetext.length - 1 ? $0c5d6d1bcb68adf1$var$brochurePath : "";
    return (0, $caba99b41008490c$export$2e2bcd8739ae039)({
        title: title,
        body: body,
        url: url,
        side: side,
        brochure: brochure
    });
}).join("")}
  ${(0, $b01af831ba87d0c3$export$2e2bcd8739ae039)()}
  ${(0, $c8fe552aeac3cb2f$export$2e2bcd8739ae039)()}
  ${(0, $fc88978aa06ef639$export$2e2bcd8739ae039)()}
	${(0, $5XAMO.default)()}
`;

})();
//# sourceMappingURL=index.ffe3db83.js.map
